import { BallsContainer } from "./BallsContainer";
import { GameConstants } from "../../GameConstants";
import { GameVars } from "../../GameVars";
import { Ball } from "./Ball";

export class BoardContainer extends Phaser.GameObjects.Container {

    public static readonly CONTAINERS_5_POSITIONS = {
        scale: 1,
        positions: [ {x: -280, y: 150},  {x: -140, y: 150},  {x: 0, y: 150},  {x: 140, y: 150}, {x: 280, y: 150}]
    };

    public static readonly CONTAINERS_6_POSITIONS = {
        scale: .8,
        positions: [ {x: -200, y: 0},  {x: 0, y: 0},  {x: 200, y: 0},  {x: -200, y: 420}, {x: 0, y: 420}, {x: 200, y: 420}]
    };

    public static readonly CONTAINERS_7_POSITIONS = {
        scale: .8,
        positions: [ {x: -260, y: 0},  {x: -85, y: 0}, {x: 85, y: 0},  {x: 260, y: 0},  {x: -200, y: 420}, {x: 0, y: 420}, {x: 200, y: 420}]
    };

    public static readonly CONTAINERS_8_POSITIONS = {
        scale: .8,
        positions: [ {x: -260, y: 0},  {x: -85, y: 0}, {x: 85, y: 0},  {x: 260, y: 0},  {x: -260, y: 420},  {x: -85, y: 420}, {x: 85, y: 420},  {x: 260, y: 420}]
    };

    public static readonly CONTAINERS_9_POSITIONS = {
        scale: .8,
        positions: [ {x: -260, y: 0}, {x: -130, y: 0},  {x: 0, y: 0}, {x: 130, y: 0},  {x: 260, y: 0},  {x: -210, y: 420},  {x: -70, y: 420}, {x: 70, y: 420},  {x: 210, y: 420}]
    };

    public static readonly CONTAINERS_10_POSITIONS = {
        scale: .8,
        positions: [ {x: -260, y: 0}, {x: -130, y: 0},  {x: 0, y: 0}, {x: 130, y: 0}, {x: 260, y: 0},  {x: -260, y: 420}, {x: -130, y: 420},  {x: 0, y: 420}, {x: 130, y: 420},  {x: 260, y: 420}]
    };

    public static currentInstance: BoardContainer;

    public ballsContainers: BallsContainer[];
    
    private ballsGroup: Phaser.GameObjects.Container;

    constructor(scene: Phaser.Scene) {
        
        super(scene);

        BoardContainer.currentInstance = this;

        this.x = GameConstants.GAME_WIDTH / 2;
        this.y = GameConstants.GAME_HEIGHT / 2;

        this.ballsContainers = [];

        this.scaleY = GameVars.scaleY;

        let containersPositions: {scale: number, positions: {x: number, y: number} []};

        switch (GameVars.levelData.length) {
            case 5:
                containersPositions = BoardContainer.CONTAINERS_5_POSITIONS;
                break;
            case 6:
                containersPositions = BoardContainer.CONTAINERS_6_POSITIONS;
                break;
            case 7:
                containersPositions = BoardContainer.CONTAINERS_7_POSITIONS;
                break;
            case 8:
                containersPositions = BoardContainer.CONTAINERS_8_POSITIONS;
                break;
            case 9:
                containersPositions = BoardContainer.CONTAINERS_9_POSITIONS;
                break;
            case 10:
                containersPositions = BoardContainer.CONTAINERS_10_POSITIONS;
                break;
            default:
        }

        this.ballsGroup = new Phaser.GameObjects.Container(this.scene);
        this.add(this.ballsGroup);

        for (let i = 0; i < GameVars.levelData.length; i ++) {

            const ballsContainer = new BallsContainer(this.scene, i, containersPositions.positions[i].x, containersPositions.positions[i].y, this.ballsGroup);
            ballsContainer.scale = containersPositions.scale;
            this.add(ballsContainer);

            this.ballsContainers.push(ballsContainer);

            const ballsIDs = GameVars.levelData[i];

            for (let j = ballsIDs.length - 1; j >= 0; j --) {

                ballsContainer.createBall(ballsIDs[j], containersPositions.scale);
            }
        }
    }

    public extractBall(id: number): void {

        this.ballsContainers[id].extractBall();
    }

    public restituteBall(id: number): void {

        this.ballsContainers[id].restituteBall();
    }

    public addBall(from: number, to: number): void {

        const ball = this.ballsContainers[from].getBall();

        this.ballsContainers[to].addBall(ball);
    }
}
